<!-- /.app -->
<div class="app has-fullwidth">
  <!--[if lt IE 10]>
    <div class="page-message" role="alert">
      You are using an <strong>outdated</strong> browser. Please
      <a class="alert-link" href="http://browsehappy.com/">upgrade your browser</a> to improve your
      experience and security.
    </div>
  <![endif]-->
  @defer (when isAuthenticated()) {
    <app-menu></app-menu>
  }

  <!-- .app-main -->
  <main class="app-main">
    <app-notification-state></app-notification-state>
    @defer (when isAuthenticated()) {
      @if (userState.isDemoAccount()) {
        <div class="d-block d-lg-none alert alert-warning mb-0 border-0 rounded-0 text-center py-2">
          <app-demo-banner></app-demo-banner>
        </div>
      }
    }
    <router-outlet></router-outlet>
    @defer (when isAuthenticated()) {
      <app-footer></app-footer>
    }
  </main>
  <!-- /.app-main -->
</div>
<!-- /.app -->
